<button (click)="handleFeedback()">
    @if (feedbackType() === 'positive') {
    <img class="feedback-icon" src="/assets/thumbs-up.svg" height="20" width="20">
    } @else if (feedbackType() === 'negative') {
    <img class="feedback-icon" src="/assets/thumbs-down.svg" height="20" width="20">
    }
</button>

<app-input-dialog #sendFeedbackDialog [title]="dialogTitle" (stepChanged)="sendStage($event)" (cancelled)="cancelCurrentAction()">
    <input-dialog-step button="<i class='fa fa-floppy-o'></i> Send Feedback" [checkValidity]="checkFeedbackMessage">
        <form #sendEmailForm>
            <div class="form-group">
                <label for="share-message" class="form-label">Message</label>
                <textarea class="form-control" id="share-message" rows="5" name="message" [(ngModel)]="feedbackMessage"></textarea>
            </div>
        </form>
    </input-dialog-step>
    <input-dialog-step button="">
        <ngb-progressbar [striped]="true" [animated]="true" [value]="actionProgress"></ngb-progressbar>
    </input-dialog-step>
</app-input-dialog>